import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import section01NewDesign from "src/shared/assets/images/newDesign/home/section01NewDesign.png";
import startHomePageSection01 from "src/shared/assets/svg/newDesign/home/startHomePageSection01.svg";
import underLineHome from "src/shared/assets/svg/newDesign/home/underLineHome.svg";
import { ButtonC } from "src/shared/components";
import useDomain from "src/shared/hooks/useDomain";
import useSWR from "swr";
import "./index.less";

const Section01WhiteLable02 = () => {
  const { nameEn } = useDomain();

  const { t } = useTranslation();

  return (
    <Row justify="center" style={{ background: "#fff" }} align="middle">
      <Col xs={24} lg={22} className="mainSection01WhiteLable02Col">
        <Row justify="center" align="middle">
          <Col
            style={{ textAlign: "center", padding: "0 4%" }}
            className="ColMainContent"
            xs={24}
            lg={12}
          >
            <Row justify="start">
              <Col
                style={{ textAlign: "start" }}
                className="domainName"
                span={24}
              >
                {nameEn}
              </Col>
              <Col style={{ textAlign: "start" }} span={24}>
                <Row align="middle" gutter={[50, 0]}>
                  <Col className="mainContent01">{t("Start")}</Col>
                  <Col>
                    <img src={startHomePageSection01} alt="" />
                  </Col>
                </Row>
              </Col>
              <Col style={{ textAlign: "start" }} span={24}>
                <Row align="middle" gutter={[50, 0]}>
                  <Col className="mainContent01">{t("Your Own")}</Col>
                </Row>
              </Col>
              <Col style={{ textAlign: "start" }} span={24}>
                <Row align="middle" gutter={[50, 0]}>
                  <Col className="mainContent03">{t("SMM Business")}</Col>
                </Row>
              </Col>
              <Col style={{ textAlign: "start" }} span={24}>
                <Row align="middle">
                  <Col>
                    <img src={underLineHome} alt="" />
                  </Col>
                </Row>
              </Col>
              <Col span={24} style={{ marginTop: "30px" }}>
                <Row justify="start" gutter={[20, 0]}>
                  <Col>
                    <ButtonC className="btnMain">{t("Craete Panel")}</ButtonC>
                  </Col>
                  <Col>
                    <ButtonC className="btnJoin">
                      {t(`Join`)} {nameEn}
                    </ButtonC>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col style={{ textAlign: "center", padding: "0 4%" }} xs={24} lg={12}>
            <img className="image" src={section01NewDesign} alt="" />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Section01WhiteLable02;
